import { Pipe, PipeTransform } from '@angular/core'
import moment from 'moment'

@Pipe({ name: 'dateDayMonthYear' })
export class DateDayMonthYearPipe implements PipeTransform {
  transform(value: moment.Moment | null): string {
    if (!value) {
      return ''
    }
    return moment(value).format('DD.MM.YYYY')
  }
}
